"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/user");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
var _default2 = exports.default = {
  name: 'CreatGrade',
  props: {
    userInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    levelNumData: {
      type: Array,
      default: []
    }
  },
  watch: {
    userInfo: {
      handler: function handler(val) {
        debugger;
        this.formValidate = val;
      },
      immediate: false,
      deep: true
    },
    levelNumData: {
      handler: function handler(val) {
        this.levelNumDataNew = val;
      },
      immediate: false,
      deep: true
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      formValidate: this.userInfo,
      loading: false,
      rules: {
        name: [{
          required: true,
          message: '请输入等级名称',
          trigger: 'blur'
        }],
        grade: [{
          required: true,
          message: '请输入等级',
          trigger: 'blur'
        }, {
          type: 'number',
          message: '等级必须为数字值'
        }],
        backColor: [{
          required: true,
          message: '请输入文字颜色',
          trigger: 'blur'
        }],
        discount: [{
          message: '请输入折扣',
          trigger: 'blur'
        }],
        experience: [{
          required: true,
          message: '请输入经验',
          trigger: 'blur'
        }, {
          type: 'number',
          message: '经验必须为数字值'
        }],
        icon: [{
          required: true,
          message: '请上传图标',
          trigger: 'change'
        }],
        backImage: [{
          required: true,
          message: '请上传背景图',
          trigger: 'change'
        }]
      },
      levelNum: [],
      levelNumDataNew: this.levelNumData
      //levelData: []
    };
  },
  mounted: function mounted() {
    for (var i = 0; i < 100; i++) {
      this.levelNum.push({
        val: i,
        name: i
      });
    }
  },
  computed: {
    levelData: function levelData() {
      var _this2 = this;
      this.levelNum.map(function (i) {
        if (_this2.levelNumDataNew.some(function (item) {
          return item === i.val;
        })) {
          i.disabled = true;
        } else {
          i.disabled = false;
        }
      });
      return this.levelNum;
    }
  },
  methods: {
    //点击颜色
    changeColor: function changeColor(e, color) {
      if (e) {
        this.$refs.userRef.clearValidate('backColor');
      }
    },
    // 点击商品图
    modalPicTap: function modalPicTap(multiple, num) {
      var _this = this;
      this.$modalUpload(function (img) {
        if (!img) return;
        if (num === 'icon') {
          _this.formValidate.icon = img[0].sattDir;
          _this.$refs.userRef.clearValidate('icon');
        } else {
          _this.formValidate.backImage = img[0].sattDir;
          _this.$refs.userRef.clearValidate('backImage');
        }
      }, multiple, 'user');
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    submitForm: (0, _validate.Debounce)(function (formName) {
      var _this3 = this;
      this.$refs.userRef.validate(function (valid) {
        if (valid) {
          _this3.loading = true;
          _this3.formValidate.id ? (0, _user.levelUpdateApi)(_this3.formValidate).then(function (res) {
            _this3.$message.success('编辑成功');
            _this3.loading = false;
            _this3.handleClose();
            _this3.$parent.getList();
          }).catch(function () {
            _this3.loading = false;
          }) : (0, _user.levelSaveApi)(_this3.formValidate).then(function (res) {
            _this3.$message.success('添加成功');
            _this3.loading = false;
            _this3.handleClose();
            _this3.$parent.getList();
          }).catch(function () {
            _this3.loading = false;
          });
        } else {
          return false;
        }
      });
    }),
    resetForm: function resetForm() {
      var _this4 = this;
      this.$nextTick(function () {
        _this4.$refs.userRef.clearValidate();
      });
      this.dialogVisible = false;
    }
  }
};